<template>
  <!-- <v-card>
    <v-card-text> -->
  <div>
    <!-- 価格表示 -->
    <v-row no-gutters>
      <v-col cols="8" sm="9" align="end">商品小計:</v-col>
      <v-col cols="4" sm="3" align="end">{{
        merchSubTotal | toPriceFormat
      }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="8" sm="9" align="end">送料小計:</v-col>
      <v-col cols="4" sm="3" align="end" v-if="showPostageSubTotal">{{
        postageSubTotal | toPriceFormat
      }}</v-col>
      <v-col cols="4" sm="3" align="end" v-else>(未算出です)</v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col cols="8" sm="9" align="end" class="text-h6">合計:</v-col>
      <v-col cols="4" sm="3" align="end" class="text-h6">{{
        totalAmount | toPriceFormat
      }}</v-col>
    </v-row>

    <!-- 追加コンテンツ -->
    <slot></slot>

    <!-- 注文確定ボタン -->
    <v-btn
      color="primary"
      class="white--text mt-5"
      rounded
      block
      large
      :disabled="orderButtonDisabled"
      :loading="loading"
      @click="executeOrder"
    >
      <span class="text-h6">注文を確定する</span>
    </v-btn>
    <div v-if="orderError" class="red--text">{{ orderError }}</div>
    <!-- </v-card-text> -->

    <!-- 注文確定時メッセージ -->
    <v-snackbar v-model="snackbar" :timeout="5000" bottom color="info" dark>
      注文を確定しました。しばらくするとトップに戻ります。
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false">
          閉じる
        </v-btn>
      </template>
    </v-snackbar>
  </div>
  <!-- </v-card> -->
</template>

<script>
export default {
  name: 'OrderExecute',
  components: {},
  props: {
    showPostageSubTotal: Boolean,
    merchSubTotal: Number,
    postageSubTotal: Number,
    totalAmount: Number,
    orderButtonDisabled: Boolean,
    orderError: String,
    executeOrderAction: Function,
  },
  data: () => ({
    // メッセージ表示フラグ
    snackbar: false,
    loading: false,
  }),
  methods: {
    // 注文実行
    async executeOrder() {
      this.loading = true;

      await this.executeOrderAction();

      this.loading = false;
    },
    // 注文確定
    orderComplete() {
      this.snackbar = true;
    },
  },
  watch: {
    snackbar: function() {
      if (!this.snackbar) {
        this.$emit('complete-message-close');
      }
    },
  },
};
</script>
